import { Component, Inject, Input, AfterViewInit, ViewChild, ContentChild, ViewChildren, QueryList, ContentChildren, TemplateRef, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';


import { MatPaginator } from '@angular/material/paginator';
import { MatSort, SortDirection } from '@angular/material/sort';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder } from '@angular/forms';

import { BehaviorSubject, combineLatest, merge, NEVER, Observable, of as observableOf, Subject, Subscription } from 'rxjs';
import { catchError, filter, startWith, switchMap } from 'rxjs/operators';
import { MatColumnDef, MatTable, MatTableDataSource } from '@angular/material/table';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ObservableInput } from 'ngx-observable-input';
import { GraphQLFilter, GraphQlQuery, IGraphQlService } from '../../../services/GraphQl/IGraphQL.service';

@Component({
  selector: 'graphql-data-table',
  templateUrl: './datatable.component.html',
  styleUrls: ['./datatable.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ]
})
export class DataTableComponent implements AfterViewInit, OnDestroy {

  _columns: string[] = [];

  isLoadingResults = true;
  resultsLength = 0;
  dataSource = new MatTableDataSource();


  @ViewChild(MatTable, { static: false }) table: MatTable<any>;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  @ContentChild("expandedDetail") expandedDetail: TemplateRef<any>;

  @ContentChildren(MatColumnDef) columnDefs: QueryList<MatColumnDef>;



  refreshSubject: Subject<boolean> = new Subject<boolean>();

  @ObservableInput()
  @Input("query")
  query$: Observable<GraphQlQuery>;

  @Input()
  columns: string[] = [];

  subscription: Subscription = null;
  

  constructor(public graphQlService: IGraphQlService) {

  }


  ngAfterViewInit() {

    this.columnDefs.forEach((def) => {
      this.columnDefs.forEach((def) => this.table.addColumnDef(def));
    });

    // updates ColumnDefs on any changes
    this.columnDefs.changes.subscribe(() => {
      this.columnDefs.forEach((def) => {
        this.columnDefs.forEach((def) => this.table.addColumnDef(def));
      });
    }); //make sure you unsubscribe!

    //
    this.sort?.sortChange?.subscribe(() => (this.paginator.pageIndex = 0));

    

    this.subscription = combineLatest(
      this.query$.pipe(filter(query => query != null)),
      merge(this.sort?.sortChange, this.paginator?.page, this.refreshSubject).pipe(startWith({}))
    ).pipe(
        switchMap(() => {
          this.isLoadingResults = true;
          
          const extraWheres: GraphQLFilter[] = [];

          /*if (this.filter.value != "") extraWheres.push({
            path: "sourcePhoneNumber", comparison: GraphQLComparision.CONTAINS, value: this.filter.value
          });*/

          const query = Object.assign({}, (<any>this.query$.source).value, {
            //wheres: this.query.wheres.concat(extraWheres),
            page: this.paginator.pageIndex,
            pageSize: this.paginator.pageSize
          });

          return this.graphQlService.getGraphQlResults(query).pipe(catchError(() => NEVER));
        })
      )
      .subscribe(response => {
        const data = response.data[(<any>this.query$.source).value.dataset];

        
        // Flip flag to show that loading has finished.
        this.isLoadingResults = false;
        this.resultsLength = data.totalCount;
        this.dataSource = data.items

      });

    this._columns = this.columns;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }


  onRefresh() {
   
    this.refreshSubject.next(true);
    
  }
}
